/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./AuthPages.module.css";
import { Form } from "src/components/ui-components/Form/Form";
import { AnchorButton } from "src/components/ui-components/Button/AnchorButton";
import { Button } from "src/components/ui-components/Button/Button";
import { useContext, useState } from "react";
import { useRouter } from "next/router";
import { CSRFContext } from "src/components/csrf/csrf";
import { AuthError } from "src/utils/api/auth";
import { httpPost } from "src/utils/http/http";
import { InputField } from "src/components/ui-components/Input/InputField";
import { useLoginUrl } from "src/hooks/useLoginUrl";
import { firstQueryValue, parseBrowserQuery } from "src/utils/links/query";
import { Logo } from "./Logo";

export function ResetConfirm() {
  const [loading, setLoading] = useState(false);
  const [confirmationCode, setConfirmationCode] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<AuthError>();
  const username = firstQueryValue(parseBrowserQuery(), "username");
  const { csrf } = useContext(CSRFContext);
  const { push } = useRouter();

  const loginUrl = useLoginUrl();

  const onSavePassword = (event: React.SyntheticEvent) => {
    event.preventDefault();
    if (password && confirmationCode.trim()) {
      setLoading(true);
      resetConfirm(csrf!, username, password, confirmationCode.trim())
        .then(() => push(`/auth/login?ref=resetConfirm`))
        .catch((err) => setError(new AuthError(err.message)))
        .then(() => setLoading(false));
    }
  };

  if (!username) {
    throw new Error("Missing password reset confirmation username");
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <Logo />
      </div>
      <div className={styles.section}>
        <Form size="L" className={styles.form}>
          <h1 className={styles.title}>
            Check your email for a confirmation code
          </h1>

          <InputField
            size="L"
            style="contained"
            label="Choose a new password"
            placeholder="Your password..."
            onChange={(event) => {
              setPassword(event.target.value);
            }}
            value={password}
            type="password"
            autoComplete="password"
            minLength={8}
            required
          />

          <InputField
            size="L"
            style="contained"
            label="Confirmation code"
            placeholder="123456"
            onChange={(event) => {
              setConfirmationCode(event.target.value);
            }}
            value={confirmationCode}
            inputMode="numeric"
            autoComplete="off"
            required
          />

          {error && (
            <p role="alert" className={styles.error}>
              {error.label}
            </p>
          )}

          <Button
            size="L"
            theme="primary"
            className={styles.button}
            onClick={onSavePassword}
            disabled={loading}
            loading={loading}
          >
            Save new password
          </Button>
        </Form>

        <hr />

        <AnchorButton
          size="L"
          theme="primary-light"
          href={loginUrl}
          className={styles.button}
        >
          Sign in
        </AnchorButton>
      </div>
    </div>
  );
}

const resetConfirm = async (
  csrf: string,
  username: string,
  password?: string,
  code?: string
) => {
  return httpPost<void>("/api/auth", {
    action: "resetConfirm",
    csrf,
    username,
    password,
    code,
  });
};
